'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var styled = require('styled-components');
var nthHookTheme = require('@narvar/nth-hook-theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const TertiaryHeaderStyled = styled__default["default"].h3.withConfig({
  componentId: "sc-u6sn9x-0"
})(_ref => {
  let {
    s
  } = _ref;
  return {
    margin: 0,
    ...s
  };
});
const TertiaryHeaderRoot = _ref2 => {
  let {
    as,
    children,
    s
  } = _ref2;
  const {
    headersSmallNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(TertiaryHeaderStyled, {
    as: as,
    s: {
      ...headersSmallNone,
      ...s
    }
  }, children);
};
const TertiaryHeader = nthHookTheme.withThemeProvider(TertiaryHeaderRoot, {
  themeTokens: ['headersSmallNone']
});

// Added this component because the theme used is associated with nth-bit-paragraph, but
// the extra styles added on top of nth-bit-paragraph mean I always have to override the
// styles anyway. This component purely renders out the theme.
const BodyTextDefaultRoot = _ref3 => {
  let {
    children,
    as,
    s,
    secondary,
    ...rest
  } = _ref3;
  const {
    bodytextDefaultNone,
    captiontextDefaultNone
  } = nthHookTheme.useTheme();
  const Element = as ?? 'span';
  return /*#__PURE__*/React__default["default"].createElement(Element, _extends__default["default"]({
    style: {
      ...bodytextDefaultNone,
      ...s,
      ...(secondary ? {
        color: captiontextDefaultNone === null || captiontextDefaultNone === void 0 ? void 0 : captiontextDefaultNone.color
      } : null)
    }
  }, rest), children);
};
const BodyTextDefault = nthHookTheme.withThemeProvider(BodyTextDefaultRoot, {
  themeTokens: ['bodytextDefaultNone', 'captiontextDefaultNone']
});
const CaptiontextDefaultRoot = _ref4 => {
  let {
    children,
    as,
    s,
    ...rest
  } = _ref4;
  const {
    captiontextDefaultNone
  } = nthHookTheme.useTheme();
  const Element = as ?? 'div';
  return /*#__PURE__*/React__default["default"].createElement(Element, _extends__default["default"]({
    style: {
      ...captiontextDefaultNone,
      ...s
    }
  }, rest), children);
};
const CaptionTextDefault = nthHookTheme.withThemeProvider(CaptiontextDefaultRoot, {
  themeTokens: ['captiontextDefaultNone']
});
const PanelHeaderRoot = _ref5 => {
  let {
    children,
    as,
    s,
    ...rest
  } = _ref5;
  const {
    panelheaderNoneNone
  } = nthHookTheme.useTheme();
  const Element = as ?? 'div';
  return /*#__PURE__*/React__default["default"].createElement(Element, _extends__default["default"]({
    style: {
      ...panelheaderNoneNone,
      ...s
    }
  }, rest), children);
};
const PanelHeader = nthHookTheme.withThemeProvider(PanelHeaderRoot, {
  themeTokens: ['panelheaderNoneNone']
});
const MetadataTextDefaultRoot = _ref6 => {
  let {
    children,
    as,
    style,
    ...rest
  } = _ref6;
  const {
    smalltextDefaultNone
  } = nthHookTheme.useTheme();
  const Element = as ?? 'div';
  return /*#__PURE__*/React__default["default"].createElement(Element, _extends__default["default"]({
    style: {
      ...smalltextDefaultNone,
      ...style
    }
  }, rest), children);
};
nthHookTheme.withThemeProvider(MetadataTextDefaultRoot, {
  themeTokens: ['smalltextDefaultNone']
});
const MetadataTextEmphasisRoot = _ref7 => {
  let {
    children,
    as,
    style,
    ...rest
  } = _ref7;
  const {
    smalltextEmphasisNone
  } = nthHookTheme.useTheme();
  const Element = as ?? 'div';
  return /*#__PURE__*/React__default["default"].createElement(Element, _extends__default["default"]({
    style: {
      ...smalltextEmphasisNone,
      ...style
    }
  }, rest), children);
};
const MetadataTextEmphasis = nthHookTheme.withThemeProvider(MetadataTextEmphasisRoot, {
  themeTokens: ['smalltextEmphasisNone']
});

exports.BodyTextDefault = BodyTextDefault;
exports.CaptionTextDefault = CaptionTextDefault;
exports.MetadataTextEmphasis = MetadataTextEmphasis;
exports.PanelHeader = PanelHeader;
exports.TertiaryHeader = TertiaryHeader;
